"use client"

import { GiNinjaStar } from "react-icons/gi";
import { motion } from 'framer-motion';

const CommonMarqueeEffect = ({ scroll_text, textClassName, starClassName }: { scroll_text: string[]; textClassName?: string; starClassName?: string }) => {

  if (!scroll_text || scroll_text.length === 0) return null;

  let displayItems = [...scroll_text];
  while (displayItems.length < 15) {
    displayItems = [...displayItems, ...scroll_text];
  }

  return (
    <>
    <div className="mx-auto overflow-hidden whitespace-nowrap">
    <div className="flex w-max flex-nowrap">
      <motion.div
        initial={{ x: 0 }}
        animate={{ x: "-50%" }}
        transition={{ 
          duration: displayItems.length * 4, 
          repeat: Infinity, 
          ease: "linear" 
        }}
        className="flex shrink-0 items-center"
      >
        {[...displayItems, ...displayItems].map((curr, index) => (
          <div className="flex items-center px-6 md:px-12" key={index}>
             <p className={`flex items-center font-medium text-xl md:text-2xl ${textClassName ?? ''}`} key={index}>
              {curr} <EyeComp starClassName={starClassName}/>
            </p>
          </div>
        ))}
      </motion.div>
    </div>
  </div>
  </>
  );
};

export default CommonMarqueeEffect;

const EyeComp = ({ starClassName }: { starClassName?: string }) => {
  return (
    <span className="inline-block pl-4 md:pl-12">
      <GiNinjaStar className={`h-[25px] w-[25px] ${starClassName ?? 'text-lightBrown'}`}/>
    </span>
  )
}
